import { render, staticRenderFns } from "./PppElementsForm.vue?vue&type=template&id=2a2823d3"
import script from "./PppElementsForm.vue?vue&type=script&lang=js"
export * from "./PppElementsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports